import BrandLogo from '../BrandLogo.vue';

export default {
  props: { menuItems: { type: Array, default: () => [] } },
  components: { BrandLogo },
  computed: {
    user() {
      return this.$store.state.user;
    },
    desktop() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    approved() {
      return this.$store.getters.isApproved;
    },
    cartCount() {
      return this.$store.getters.cartCount;
    },
    unreadNotifications() {
      return this.$store.state.mobileNotifications.notificationsNew.length;
    },
    showCart() {
      return this.approved && this.cartCount > 0;
    },
  },
  methods: {
    onInput(value) {
      if (!value && !this.desktop) this.CloseDrawer();
      if (value && !this.desktop) this.$nextTick(this.focusMenu);
    },
    focusMenu() {
      if (!this.sidebar || this.desktop || this.$el.contains(document.activeElement)) return;
      const firstLink = this.$el.querySelector('a[href]');
      if (firstLink) firstLink.focus();
    },
    CloseDrawer() {
      this.$store.dispatch('app/SetSidebar', false);
    },
    UserLogout() {
      this.CloseDrawer();
      this.$store.dispatch('UserLogout');
      this.$router.push('/');
    },
  },
};
